/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import CheckSummary from './CheckSummary';
import DetailsList from './DetailsList';
import PassingMessage from './PassingMessage';
import ValidatingLoader from './ValidatingLoader';

import { VersionStatus } from 'app/developer-v3/constants';

import type {
  ValidationResultSetWrapper,
  ValidationResultType,
} from 'app/developer-v3/types';

type Props = {
  checkType: ValidationResultType;
  checkWrapper: ValidationResultSetWrapper;
  handleDetailsClick: (
    item: string,
    iconType: string,
    checkType: string,
    violationType: string
  ) => void;
  isPublished: boolean;
  isValidating: boolean;
  versionStatus: VersionStatus;
};

const Styles = {
  root: css`
    padding: 15px;
  `,
};

export default function Details({
  checkType,
  checkWrapper,
  handleDetailsClick,
  isPublished,
  isValidating,
  versionStatus,
}: Props) {
  const { totalFailures, results } = checkWrapper;
  return (
    <section css={Styles.root}>
      <PassingMessage
        show={!isValidating && !results.length}
        type={checkType}
      />
      <CheckSummary
        checkType={checkType}
        count={totalFailures}
        hasLoaded={!isValidating}
        isPublished={isPublished}
        versionStatus={versionStatus}
      />
      {isValidating ? (
        <ValidatingLoader label="Running validations..." padding="20px 0" />
      ) : (
        <DetailsList
          checks={results}
          handleDetailsClick={handleDetailsClick}
          type={checkType}
        />
      )}
    </section>
  );
}
